export const PAYME_EVENTS = {
    PAYME_HOME_SELECTED: 'PayME Home Selected',
    PAYME_VIEWED: 'PayME Viewed',
    PAYME_CREATION_SUCCEEDED: 'PayME Creation Succeeded',
    PAYME_CREATION_FAILED: 'PayME Creation Failed',
    PAYME_PREVIEWED: 'PayME Previewed',
    PAYME_SETTINGS_SELECTED: 'PayME Settings Selected',
    PAYME_SHARING_SUCCEEDED_TO_START: 'PayME Sharing Succeeded to Start',
    PAYME_SHARING_COMPLETION_SUCCEEDED: 'PayME Sharing Completion Succeeded',
    PAYME_SHARING_COMPLETION_FAILED: 'PayME Sharing Completion Failed',
    PAYME_BRANCH_ADDITION_STARTED: 'PayME Branch Addition Started',
    PAYME_BRANCH_ADDITION_SUCCEEDED: 'PayME Branch Addition Succeeded',
    PAYME_BRANCH_ADDITION_FAILED: 'PayME Branch Addition Failed',
    PAYME_ACTIVATION_ENABLED_SUCCEEDED: 'PayME Activation Enabled Succeeded',
    PAYME_ACTIVATION_ENABLED_FAILED: 'PayME Activation Enabled Failed',
    PAYME_ACTIVATION_DISABLED_SUCCEEDED: 'PayME Activation Disabled Succeeded',
    PAYME_ACTIVATION_DISABLED_FAILED: 'PayME Activation Disabled Failed',
    PAYME_CHECKOUT_INFO_SELECTED: 'PayME Checkout Info Selected',
};
